export default __webpack_public_path__ + "static/media/Tasset of the Savage Slaughter.63f22cd8.jpg";